import React from "react";
import { Modal } from "../../shared/Modal/Modal";
import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import styles from "./styles.module.scss";

/**
 * @param {{
 *  isOpen: boolean;
 *  onClose: () => void;
 *  products: Array<{
 *    id: string;
 *    name: string;
 *    image: string;
 *    price: number;
 *    quantity: number;
 *  }>;
 * }} param0
 */
export function ShopifyProductsModal({ isOpen, onClose, products }) {
  var { data: account } = useCurrentAccountQuery();
  var { tCommon: t } = useAppTranslation.Common();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.root}
      header={<Modal.Title>{t("shopify_products_modal.label")}</Modal.Title>}
    >
      {products.map((product) => (
        <div key={product.id} className={styles.product}>
          <div className={styles.inner}>
            <img alt={product.name} src={product.image} />
            <div className={styles.name}>{product.name}</div>
          </div>
          <div>
            <div className={styles.price}>
              {account.globalSettings.currencySymbol}
              {product.price}
            </div>
            <div className={styles.quantity}>
              {t("shopify_products_modal.quantity", {
                count: product.quantity,
              })}
            </div>
          </div>
        </div>
      ))}
    </Modal>
  );
}
